import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./locales/en/translation.json";
import translationKr from "./locales/ko/translation.json";

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
  ko: {
    translation: translationKr,
  },
};

i18n
  // .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: (code) => {
      return code || "en";
    },

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    detection: { caches: [] },
    react: {
      defaultTransParent: "div", // a valid react element - required before react 16
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: true, // allow <br/> and simple html elements in translations
      transKeepBasicHtmlNodesFor: ["br", "strong", "i"], // don't convert to <1></1> if simple react elements
    },
  });

export default i18n;
